export enum F360UnitDate {
  Date = "D",
  Day = "d",
  Month = "M",
  Year = "y",
  Hour = "h",
  Minute = "m",
  Second = "s",
  Millisecond = "ms",
  Days = "days",
  week = "week"
}

export interface IF360Date {
  getNewDate(date: Date | string | null): Date;
  now(): Date;
  format(date: Date | string, format: string, formatFrom?: string): string;
  isValid(date: Date | string): boolean;
  setLocale(locale: string): void;
  setPlugins(plugins: unknown): void;
  // toMillisecond(date: Date | string): number
  // toSecond(date: Date | string): number
  // toMinute(date: Date | string): number
  // toHour(date: Date | string): number
  // currentMonth(date: Date | string): number
  // currentYear(date: Date | string): number
  // currentDayOfWeek(date: Date | string): number
  // currentDayofMonth(date: Date | string): number
  // currentDayOfYear(date: Date | string): number
  // getDateInformation(date: Date | string, unit: F360UnitDate): number
  add(date: Date | string, unit: number, ManipulateType?: F360UnitDate): Date;
  subtract(
    date: Date | string,
    unit: number,
    ManipulateType?: F360UnitDate
  ): Date;
  startOf(date: Date | string, OpUnitType: F360UnitDate): Date | string;
  endOf(date: Date | string, OpUnitType: F360UnitDate): Date | string;
  handleFormat(format: F360UnitDate): unknown | undefined;
  isBetween(
    date: string | Date,
    compareStart: string | Date,
    compareEnd: string | Date,
    OpUnitType: F360UnitDate
  ): boolean;
  getDateFromMonth(month: number): Date;
  getMonth(date: Date | string): number;
  getFromTimezone(date: Date | string): Date;
  getMinimum(dateRange: Date[] | string[]): Date;
  isSame(date: Date | string, compare: Date | string): boolean;
  // isBetween(params: DateBetween<T>, compare: "day" | "month" | "year"): boolean
  isBefore(date: Date | string, compareDate: Date | string): boolean;
  // isAfter(date: Date | string, compareDate: Date | string): boolean
  // isLeapyear(date: Date | string): boolean
  getTotalDays(date: Date | string, compareDate: Date | string): number;
  getDiff(
    date: Date | string,
    compareDate: Date | string,
    unit?: F360UnitDate | boolean
  ): number;
  getHour(date: Date): string;
}
